define('views/modules/template/edit/calendar/animated-session/session-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/animated-session/session/session-edit-content'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VSessionEditContent
) {

    var VTemplateSessionEditContent = VSessionEditContent.extend({

        /////////////
        // Actions //
        /////////////

        onSaveClick: function() {
            if (this.model.isValid()) {
                this.onSubmit();
                this._onSuccess();
            }
        },

        setExercises: function() {
            if (this.hasCollectionChanged()) {
                this.model.setExercises(this.collection.toJSON());
            }
        },

    });

    return VTemplateSessionEditContent;
});

